import { useState } from "react";

export const UseModal = () => {
  const [modal, setModal] = useState(false);

  const [modalContent, setModalContent] = useState("El contenido del modal");
  const [bigModal, setBigModal] = useState(false);

  const handleModal = (content = false, bigModal = false) => {
    setModal(!modal);
    if (content) {
      setModalContent(content);
      setBigModal(bigModal);
    }
  };

  const openModal = (content = false, big = false) => {
    if (content) {
      setModalContent(content);
      setBigModal(big);
    }
    setModal(true);
  };

  const closeModal = () => {
    setModal(false);
  };

  return { modal, handleModal, modalContent, bigModal, openModal, closeModal };
};
